import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    stepperActions: {
        padding: '5rem',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        [theme.breakpoints.down(600)]:{
            padding: '3rem'
        },
        [theme.breakpoints.down(450)]:{
            padding: '1rem',
        },
        [theme.breakpoints.down(400)]:{
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }
}));


export default useStyles;